import { render, staticRenderFns } from "./CustomerRatingCard.vue?vue&type=template&id=5bf8bdcf&scoped=true&"
import script from "./CustomerRatingCard.vue?vue&type=script&lang=ts&"
export * from "./CustomerRatingCard.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerRatingCard.vue?vue&type=style&index=0&id=5bf8bdcf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf8bdcf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
